import { Avatar } from '@material-ui/core'
import React, { useState } from 'react'
import './ChatScreen.css'

function ChatScreen() {
    const [input,setInput] = useState('') 
    const [messages,setMessages] = useState([
        {
            name:"Ellen",
            image:"https://image.shutterstock.com/image-photo/closeup-portrait-young-attractive-stylish-600w-1753317011.jpg",
            message:'The time has come'
        },
        {
            name:"Ellen",
            image:"https://image.shutterstock.com/image-photo/closeup-portrait-young-attractive-stylish-600w-1753317011.jpg",
            message:'We should go now'
        },
        {
            message:"We don't have any other choices do we?"
        },
        {
            name:"Ellen",
            image:"https://image.shutterstock.com/image-photo/closeup-portrait-young-attractive-stylish-600w-1753317011.jpg",
            message:"We did"
        }
        
    ])

    const handleSend = e => {
        e.preventDefault();
        setMessages([...messages,{message:input}]);
        setInput("");
    }

    return (
        <div className="chatScreen">
            <p className="chatScreen__timestamp">YOU MATCHED WITH ELLEN ON 15/12/2020</p>
            {messages.map(message => 
                message.name ? (
                    <div className="chatScreen__message">
                        <Avatar className="chatScreen_image" src={message.image} alt={message.name}/>
                        <p className="chatScreen__text">{message.message}</p>
                    </div>
                ) : (
                <div className="chatScreen__message">
                    <p className="chatScreen__textUser">{message.message}</p>
                </div>
            ))}

            <form className="chatScreen__input">
                <input 
                className="chatScreen__inputField"
                placeholder="Type a message"
                type="text" 
                value={input}
                onChange={(e)=>setInput(e.target.value)}/>
                <button 
                className="chatScreen__inputButton"
                onClick={handleSend}
                >SEND</button>
            </form>
        </div>
    )
}

export default ChatScreen
